import type { Command } from '@atlassian/jira-command-palette';

export const noSortNoFilterOverride = (_search: string, selectedCommands: Command[]): Command[] =>
	selectedCommands;
